/**
 * Identity fields of an export directive. The BFF prints `customerId` as
 * "ID de cliente" and falls back to `companyId` (the internal uuid) only when
 * the short code is missing, so the two must not be swapped.
 */
export interface ExportIdentity {
  companyName: string;
  /** Internal customer uuid. */
  companyId: string;
  /** Short client-facing company identifier (e.g. `608UDE0KL8`). */
  customerId: string | null;
}

export function buildExportIdentity(args: {
  companyName?: string | null;
  keyId?: string | null;
  customerUuid?: string | null;
}): ExportIdentity {
  const shortId = args.keyId?.trim();

  return {
    companyName: args.companyName?.trim() ?? '',
    companyId: args.customerUuid?.trim() ?? '',
    customerId: shortId && shortId !== 'N/A' ? shortId : null,
  };
}
